import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { getNestedError } from "../../../utils";

const MyDropdownSelect = (props) => {
  const {
    defaultValue,
    name,
    options,
    placeholder,
    disabled,
    dense = false,
    outlined = true,
    onChange = () => {},
    style = {},
    dropdownStyle = {},
    ...rest
  } = props;

  const {
    trigger,
    register,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const selectedValue = watch(name);

  const dropdownRef = useRef(null);
  const listRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleSelect = (value) => {
    setValue(name, value);
    onChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen && listRef.current) {
      const selectedOption = listRef.current.querySelector(
        `.option-${selectedValue}`
      );
      if (selectedOption) {
        listRef.current.scrollTop =
          selectedOption.offsetTop - selectedOption.offsetHeight;
      }
    }
  }, [isOpen, selectedValue]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    if (defaultValue && !selectedValue) {
      setValue(name, defaultValue);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedValue) trigger(name);
    else clearErrors(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  return (
    <div className="relative" ref={dropdownRef}>
      <input type="hidden" {...register(name)} />

      <div
        onClick={() => (!disabled ? setIsOpen((prev) => !prev) : null)}
        className={`${outlined ? "border rounded" : "border-b"} ${
          !dense ? "px-4 h-[56px]" : "px-2 h-9"
        } flex items-center gap-4 justify-between ${
          !disabled ? "cursor-pointer bg-white" : "bg-[#F5F5F5]"
        } text-xl ${
          getNestedError(errors, name)
            ? "border-error"
            : isOpen
            ? "border-primary"
            : "border-gray-border"
        } ${rest.className || ""}`}
        style={{
          transition: "transform 0.2s ease",
          ...style,
        }}
      >
        {selectedValue ? (
          <span className={`${!dense ? "md:text-base" : ""} text-sm`}>
            {options.find((c) => c.value === selectedValue)?.label}
          </span>
        ) : (
          <span
            className={`opacity-30 ${!dense ? "md:text-base" : ""} text-sm"`}
          >
            {placeholder}
          </span>
        )}
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
          size="xs"
          color="#888"
        />
      </div>

      {isOpen && !disabled && (
        <div
          className="absolute mt-2 md:p-2 p-1 bg-white rounded w-full z-10 border-gray-border border"
          style={{
            boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)",
            ...dropdownStyle,
          }}
        >
          <ul className="small-scroll max-h-40 overflow-y-auto" ref={listRef}>
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`md:px-4 px-2 hover:bg-gray-100 cursor-pointer ${
                  selectedValue === option.value
                    ? "font-semibold text-primary"
                    : "text-gray-dark"
                } option-${option.value} ${
                  !dense ? "md:text-base" : ""
                } text-sm md:py-2 py-1`}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
      {getNestedError(errors, name) && (
        <p className="text-error text-sm">
          {getNestedError(errors, name)?.message}
        </p>
      )}
    </div>
  );
};

export default MyDropdownSelect;
